<div class="app-toast-container">
  <div class="title-container">
    <div class="icon"></div>
    <div class="title">
      {{ title }}
    </div>
  </div>
  <div class="message">{{ message }}</div>
</div>
